﻿(function ($) {
    $(document).ready(function () {
        displayCookiePopup = function (templateMarkup) {
            $.notify({},
                {
                    element: 'body',
                    position: null,
                    type: 'info',
                    allow_dismiss: true,
                    newest_on_top: true,
                    showProgressbar: false,
                    placement: {
                        from: 'top',
                        align: 'center'
                    },
                    offset: 0,
                    spacing: 0,
                    z_index: 2001,
                    delay: 0,
                    timer: 1000,
                    url_target: '_blank',
                    animate: {
                        enter: 'animated fadeInDown',
                        exit: 'animated fadeOutUp'
                    },
                    icon_type: 'class',
                    template: templateMarkup
                });
        };

        setCookie = function (cookieValue) {
            $.ajax({
                type: 'POST',
                url: '' + $("#hdnSetCookieDisclaimerUrl").val() + '',
                cache: false,
                data: {
                    cookieValue: cookieValue
                },
                success: function () {
                    location.reload();
                }
            });
        };
    
        var templateMarkup = $('#cookie-disclaimer-holder').html();
        if (templateMarkup && templateMarkup !== '') {
            displayCookiePopup(templateMarkup);
        }

        $('.cookie-disclaimer-btn').click(function () {
            var cookieValue = $(this).data('value');
            setCookie(cookieValue);
        });
    });
})(jQuery);